var render, staticRenderFns
import script from "./Tiles.vue?vue&type=script&lang=js&"
export * from "./Tiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85cab5f6')) {
      api.createRecord('85cab5f6', component.options)
    } else {
      api.reload('85cab5f6', component.options)
    }
    
  }
}
component.options.__file = "src/components/Tiles.vue"
export default component.exports